export default "__VITE_ASSET__$nq59LGy__"